export default "__VITE_ASSET__DYQmmS0A__"